import { loadImage } from "./loadImage";

interface Options {
    width?: number;
    height?: number;
    crossOrigin?: boolean;
}

export const loadImageToCanvas = async (canvas: HTMLCanvasElement, src: string, options?: Options) => {
    const { image, width, height } = await loadImage(src, !!options?.crossOrigin);
    const context = canvas.getContext("2d");
    if (!context) return;
    context.clearRect(0, 0, canvas.width, canvas.height);
    canvas.width = options?.width ?? width;
    canvas.height = options?.height ?? height;
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
};
